import { useState } from "react";
import { KeyRound, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { changePassword } from "@/lib/api";

const inputCls =
  "w-full bg-[#0D0D10] border border-white/15 text-white text-sm px-3 py-2.5 focus:border-[#FFD400] focus:outline-none transition-colors placeholder:text-slate-600";

export default function AdminSettings({ email }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) {
      toast.error("New password must be at least 8 characters");
      return;
    }
    if (next !== confirm) {
      toast.error("New password and confirmation do not match");
      return;
    }
    setBusy(true);
    try {
      await changePassword(current, next);
      toast.success("Password changed successfully!");
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Something went wrong, please try again");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md" data-testid="admin-settings">
      <div className="border border-white/10 p-6">
        <h3 className="font-editorial font-bold text-white text-lg flex items-center gap-2">
          <KeyRound size={16} className="text-[#FFD400]" /> Change Password
        </h3>
        <p className="font-mono-meta text-[10px] text-slate-500 mt-2">{email}</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <label className="block">
            <span className="font-mono-meta text-[10px] text-slate-400 uppercase tracking-widest block mb-1.5">Current Password</span>
            <input data-testid="settings-current-password-input" type="password" className={inputCls} value={current} onChange={(e) => setCurrent(e.target.value)} />
          </label>
          <label className="block">
            <span className="font-mono-meta text-[10px] text-slate-400 uppercase tracking-widest block mb-1.5">New Password (min 8 characters)</span>
            <input data-testid="settings-new-password-input" type="password" className={inputCls} value={next} onChange={(e) => setNext(e.target.value)} />
          </label>
          <label className="block">
            <span className="font-mono-meta text-[10px] text-slate-400 uppercase tracking-widest block mb-1.5">Confirm New Password</span>
            <input data-testid="settings-confirm-password-input" type="password" className={inputCls} value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </label>
          <button
            type="submit"
            disabled={busy}
            data-testid="settings-change-password-button"
            className="w-full flex items-center justify-center gap-2 bg-[#FFD400] text-[#0D0D10] px-6 py-3 text-sm font-bold hover:bg-[#E6BE00] transition-colors disabled:opacity-60"
          >
            <ShieldCheck size={15} /> {busy ? "Changing..." : "Change Password"}
          </button>
        </form>
      </div>
    </div>
  );
}
